exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HeaderLink__navLink___kp25u {\n    color: white !important;\n    font-weight: lighter;\n    font-size: 18px;\n    padding: 0 !important;\n}\n\n.HeaderLink__navLink___kp25u:hover {\n    font-weight: bold;\n}\n\n.HeaderLink__linkWrapper___3phoD {\n    height: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    margin: 0 15px !important;\n}\n\n.HeaderLink__active___15oWc {\n    border-bottom: 3px solid #ff8e42;\n}\n\n.HeaderLink__active___15oWc .HeaderLink__navLink___kp25u {\n    font-weight: bold;\n}\n\n@media screen and (max-width: 990px) {\n    .HeaderLink__linkWrapper___3phoD {\n        margin: 0 8px !important;\n    }\n}\n\n@media screen and (max-width: 800px) {\n    .HeaderLink__navLink___kp25u {\n        padding: 10px 0 !important;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"navLink": "HeaderLink__navLink___kp25u",
	"linkWrapper": "HeaderLink__linkWrapper___3phoD",
	"active": "HeaderLink__active___15oWc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/HeaderLink/HeaderLink.css
// module id = 376
// module chunks = 0